import { render } from "./DistributorLogin.vue?vue&type=template&id=5dcf5768&scoped=true"
import script from "./DistributorLogin.vue?vue&type=script&lang=js"
export * from "./DistributorLogin.vue?vue&type=script&lang=js"

import "./DistributorLogin.vue?vue&type=style&index=0&id=5dcf5768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcf5768"]])

export default __exports__